export const CONSONANT_VOWEL_PAIRS_S_T = [

    // ㅅ
  {
        id: 1,
        korean: "사",
        english: "sa",

    },
    {
        id: 2,
        korean: "세",
        english: "se",

    },
    {
        id: 3,
        korean: "시",
        english: "si",

    },
    {
        id: 4,
        korean: "소",
        english: "so",

    },
    {
        id: 5,
        korean: "스",
        english: "seu",

    },
    {
        id: 6,
        korean: "서",
        english: "seo",

    },
    {
        id: 7,
        korean: "샤",
        english: "sya",

    },
    {
        id: 8,
        korean: "새",
        english: "sae",

    },
    {
        id: 9,
        korean: "셰",
        english: "sye",

    },
    {
        id: 10,
        korean: "쇼",
        english: "syo",

    },
    {
        id: 11,
        korean: "셔",
        english: "syeo",

    },
    {
        id: 12,
        korean: "슈",
        english: "syu",

        

    },

    {
        id: 13,
        korean: "산",
        english: "san",

        

    },
    {
        id: 14,
        korean: "샄",
        english: "sak",

        

    },
    {
        id: 15,
        korean: "심",
        english: "sim",
        

    },
    {
        id: 16,
        korean: "샅",
        english: "sat",
        

    },
    {
        id: 17,
        korean: "샇",
        english: "sah",
        

    },
    {
        id: 18,
        korean: "섭",
        english: "seob",
        

    },
          {
        id: 19,
        korean: "슬",
        english: "seul",
        

    },
    {
        id: 20,
        korean: "샂",
        english: "sat",
        

    },
    {
        id: 21,
        korean: "샊",
        english: "saekk",
        

    },
    {
        id: 22,
        korean: "샌",
        english: "saen",
        

    },
    {
        id: 23,
        korean: "싀",
        english: "sui",
        

    },
    {
        id: 24,
        korean: "숴",
        english: "swo",
        

    },

    {
        id: 25,
        korean: "샷",
        english: "syat",
        

    },
    {
        id: 26,
        korean: "샃",
        english: "sat",
        

    },
    {
        id: 27,
        korean: "캇",
        english: "kat",
        
    },
    {
        id: 28,
        korean: "앗",
        english: "at",
        
    },
    {
        id: 29,
        korean: "탓",
        english: "tat",
        
    },
    {
        id: 30,
        korean: "삿",
        english: "sat",
        
    },
    
    
    
];

